import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

const GetSources = () => {
    return useQuery(
        ["get-sources"],
        () =>
            request({
                url: `/meta/admin/sources`,
                method: "GET",
            }),
        {
            staleTime: 5 * 60 * 1000, // 5 minutes - sources data doesn't change frequently
            cacheTime: 10 * 60 * 1000, // 10 minutes
        }
    );
};

export default GetSources;
